import React, { useContext, useEffect, useState } from "react";
import Nabvar from "./Navbar";
import Footer from "./footer";
import Plans from "./Plans";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { RxCrossCircled } from "react-icons/rx";
import "./HomeLayout.css";
import "./Pricing.css";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import { GlobalContext } from "../Context/GlobalState";

const Pricing = () => {
  const { setTransactionLoaderState } = useContext(GlobalContext);
  const [accessData, setAccessData] = useState([]);

  const getAccessData = async () => {
    setTransactionLoaderState(true);
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
        redirect: "follow",
      };

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetSubscriptionPlansModule`,
        requestOptions
      );
      const data = await response.json();
      if (data.status === "0") {
        setAccessData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching access data:", error);
      setTransactionLoaderState(false);
    }
  };

  useEffect(() => {
    getAccessData();
    const script = document.createElement("script");
    script.src = "./on_seo.js";
    script.type = "module";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="billpunch-home pricing-page">
      <Nabvar />
      <main>
        <div className="pricing-page__plans">
          <Plans />
        </div>
        <section className="pricing-comparison" aria-labelledby="comparison-title">
          <header className="pricing-comparison__intro">
            <span className="pricing-comparison__eyebrow">FIND YOUR FIT</span>
            <h2 id="comparison-title">Every feature. A clearer choice.</h2>
            <p>Compare what’s included and choose the right plan for your team.</p>
            <div className="pricing-comparison__legend">
              <span><IoMdCheckmarkCircleOutline aria-hidden="true" /> Included</span>
              <span><RxCrossCircled aria-hidden="true" /> Not included</span>
            </div>
          </header>
          <div className="pricing-comparison__modules">
            {accessData.map((module, index) => (
              <section className="pricing-module" key={index} aria-labelledby={`pricing-module-${index}`}>
                <header className="pricing-module__heading">
                  <span className="pricing-module__number" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
                  <div>
                    <h3 id={`pricing-module-${index}`}>{module.module}</h3>
                    <p>{module.submodule.length} features to compare</p>
                  </div>
                </header>
                <div className="pricing-module__scroll" role="region" aria-label={`${module.module} plan comparison`}>
                  <table className="pricing-module__table" aria-labelledby={`pricing-module-${index}`}>
                    <thead>
                      <tr>
                        <th scope="col">Features</th>
                        <th scope="col">Basic</th>
                        <th scope="col" className="pricing-module__premium">Premium</th>
                        <th scope="col">Enterprise</th>
                      </tr>
                    </thead>
                    <tbody>
                      {module.submodule.map((submodule, subIndex) => (
                        <tr key={subIndex}>
                          <th scope="row">{submodule.submodule_name}</th>
                          {["basic", "premium", "enterprise"].map((plan) => (
                            <td key={plan} className={plan === "premium" ? "pricing-module__premium" : undefined}>
                              <span className={`pricing-module__status ${submodule[plan] === "Y" ? "is-included" : "is-excluded"}`}>
                                {submodule[plan] === "Y" ? <IoMdCheckmarkCircleOutline aria-hidden="true" /> : <RxCrossCircled aria-hidden="true" />}
                                <span className="visually-hidden">{submodule[plan] === "Y" ? "Included" : "Not included"}</span>
                              </span>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </section>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Pricing;
